import {BILLING_PERIOD_MONTHLY, BILLING_PERIOD_YEARLY, type BillingPeriod, type Pricing} from "@/shared/plans";

// Convert the given number to a string with 2 decimal digits.
// If the given number (rounded to 2 decimal digits) is an integer, then return a string without any
// decimal digits. That is, never return a string ending with ".00".
// Examples:
//   2       ->  "2"
//   2.5     ->  "2.50"
//   2.433   ->  "2.43"
//   2.999   ->  "3"
export function priceToString(price: number) {
  const priceString = price.toFixed(2);
  if (priceString.endsWith(".00")) {
    return price.toFixed(0);
  } else {
    return priceString;
  }
}

export function getPrice(price: Pricing, billingPeriod: BillingPeriod, lineBreak = true, showMonthlyForYearly = true) {
  const {[BILLING_PERIOD_MONTHLY]: monthly, [BILLING_PERIOD_YEARLY]: yearly} = price;
  if (billingPeriod === BILLING_PERIOD_MONTHLY) {
    return `${priceToString(monthly)} €/month`;
  } else {
    if (showMonthlyForYearly) {
      return (
        <>
          {priceToString(yearly / 12)} €/month
          {lineBreak ? <br /> : " "}({priceToString(yearly)} €/year)
        </>
      );
    } else {
      return `${priceToString(yearly)} €/year`;
    }
  }
}
